import {
  IAssessmentChecklistItem,
  IAssessmentDetail,
  IAssessmentQuestionTable,
} from "@/interfaces/assessments/IAssessmentDetails";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  checklistStatusId,
  localStorageKey,
  successStatusCodes,
} from "@/utils/constants";
import { calculatePercentile, getComponentUiText } from "@/utils/utilities";
import {
  addChecklistItemToExistChecklistItemGroup,
  createChecklistGroupMetrics,
  getChecklistGroupMetrics,
  getChecklistGroups,
  getChecklistGroupTemplateMetrics,
  getChecklistGroupTemplates,
  getDataChecklist,
  getDataChecklistGroup,
  removeActionTable,
  postChecklistGroup,
  putChecklistGroup,
  getDataChecklistForecasts,
  putChecklistSuggestedAction,
  deleteChecklistItemGroup,
} from "@/services/recommend";
import { ISuggestedActionDetail } from "@/interfaces/recommendations/IActionInterfaces";
import {
  getChecklistAll,
  getCheckListStatusDetails,
  getMetricFromChecklistId,
  initialChecklistByCategory,
  makeParentNonHierarchical,
  updateChecklistAnswer,
} from "@/services/assessment";
import get from "lodash/get";
import store from "@/store";
import { showErrorAPI, showToastMessage } from "@/services/apiRoutes";
import { Assessment, Checklist } from "@/services/apiRoutes/routes";
import eventEmitter from "@/utils/eventEmitter";

const recommendModule = {
  namespaced: true,
  state() {
    return {
      checklistData: {} as IAssessmentDetail,
      checklistGroupData: {},
      latestChecklistDetail: {} as IAssessmentDetail,
      checklistGroupMetrics: [],
      checklistStatus: "" as string,
      percentileChecklistGroupMetrics: {
        percentile_90: 0,
        percentile_75: 0,
        percentile_33: 0,
      },
      ChecklistGroupTemplateMetrics: [],
      dataChecklistForecasts: [],
      percentileChecklistGroupTemplateMetrics: {
        percentile_90: 0,
        percentile_75: 0,
        percentile_33: 0,
      },
      checklistAssessmentQuestions: [],
      isFetchingChecklistAssessmentQuestion: true,
      listCheckListGroupId: [],
      listFilterCheckListGroupTemplate: [],
      getIsHRemoveApplied: false,
      checklistReportId: null,
      checklists: [] as Array<IAssessmentDetail>,
      recommendChecklistGroupMetrics: [],
      recommendPercentileChecklistGroupMetrics: {
        percentile_90: 0,
        percentile_75: 0,
        percentile_33: 0,
      },
      selectedChecklistAssessmentQuestions: [],
      dataAction: {},
      checklistGroup: [],
      deletedChecklistsAssessment: [],
      isChangeTitleAction: false,
      isChangeDescriptionAction: false,
      checklistMetrics: {},
      isCreatingAction: false,
      listStepActionsPlan: [],
      listStepRemoved: [],
    };
  },

  getters: {
    getIsHRemoveApplied: (state) => state.getIsHRemoveApplied,
    getChecklistId: (state: any) => state.checklistData?.checklistId,
    getChecklistReportId: (state: any) => state.checklistReportId,
    getChecklists: (state: any) => state.checklists,
    getChecklistDetail: (state: any) => state.checklistData,
    getChecklistGroup: (state: any) => state.checklistGroupData,
    getLatestChecklistId: (state: any) =>
      state.latestChecklistDetail?.checklistId,
    getLatestChecklistDetail: (state: any) => state.latestChecklistDetail,
    getChecklistDetailById: (state: any) => (id: number) => {
      let data;
      state.checklists.forEach((item) => {
        if (item.checklistId === id) data = item;
        else {
          item.checklistItem &&
            item.checklistItem.forEach((itemCl) => {
              if (itemCl.checklistId === id) data = itemCl;
            });
        }
      });
      if (data) return data;
      else return {};
    },
    getForecastToIdAction: (state: any) => (id: number) => {
      const data = state.dataChecklistForecasts
        .sort((a, b) => {
          return (
            new Date(a.forecastDate).getTime() -
            new Date(b.forecastDate).getTime()
          );
        })
        .find((item) => item.checklistForecastGroupIds.includes(id));
      return data;
    },
    getChecklistAssessmentQuestions: (state: any) => (isFilter: boolean) => {
      if (!isFilter || !state.getIsHRemoveApplied) {
        return state.checklistAssessmentQuestions;
      }

      const filterChecklistItems = (items: any[], filterList: any[]): any[] => {
        return items
          .filter((item) => item && !filterList.includes(item.checklistItemId))
          .map((item) => {
            if (item?.checklistChildren?.length > 0) {
              return {
                ...item,
                checklistChildren: filterChecklistItems(
                  item.checklistChildren,
                  filterList,
                ),
              };
            }
            return item;
          });
      };

      return filterChecklistItems(
        state.checklistAssessmentQuestions,
        state.listFilterCheckListGroupTemplate,
      );
    },
    getCurrentChecklistItem: (state: any) => (checklistItemData: any) => {
      let checklistItem;

      const findItem = (
        array: IAssessmentChecklistItem[],
        checklistItemId: number,
      ) => {
        for (const item of array) {
          if (item.checklistItemId === checklistItemId) {
            checklistItem = item;
            break;
          }
          findItem(item.checklistChildren || [], checklistItemId);
        }
      };
      findItem(
        state.checklistAssessmentQuestions,
        checklistItemData.checklistItemId,
      );
      return checklistItem ?? {};
    },
    getChecklistGroupMetrics: (state: any) => state.checklistGroupMetrics,
    getRecomChecklistGroupMetrics: (state: any) =>
      state.recommendChecklistGroupMetrics,
    getRecomChecklistMetrics: (state) => state.checklistMetrics,
    isChangeEditAction: (state: any) =>
      state.isChangeTitleAction ||
      state.isChangeDescriptionAction ||
      state.deletedChecklistsAssessment.length > 0,
  },
  mutations: {
    INITIALISE: (state: any) => {
      const isRemove = JSON.parse(
        localStorage.getItem(localStorageKey.isRemove) || "false",
      );
      state.getIsHRemoveApplied = isRemove;
    },
    INITIAL_CHANGE_ORG_USER: (state: any) => {
      // Reset assessment state when changing org or login user.
      state.checklistReportId = "";
    },
    SET_CHECKLIST_DATA: (state: any, payload: any) => {
      const currentChecklist = state.latestChecklistDetail;
      if (currentChecklist?.checklistId !== payload.checklistId) {
        state.checklistGroupMetrics = [];
        state.ChecklistGroupTemplateMetrics = [];
        state.checklistAssessmentQuestions = [];
      }
      state.latestChecklistDetail = payload;
    },
    SET_IS_HIDE_REMOVE: (state: any, isRemove: boolean) => {
      localStorage.setItem(localStorageKey.isRemove, JSON.stringify(isRemove));
      state.getIsHRemoveApplied = isRemove;
    },
    SET_CHECKLIST_GROUP_METRICS: (state: any, payload: any) => {
      state.checklistGroupMetrics = payload;
    },
    SET_RECOM_CHECKLIST_GROUP_METRICS: (state: any, payload: any) => {
      state.recommendChecklistGroupMetrics = payload;
    },
    UPDATE_RECOM_CHECKLIST_GROUP_METRICS_SCORE: (state: any, payload: any) => {
      state.recommendChecklistGroupMetrics.forEach((group) => {
        const findGroup = payload.find(
          (i) => i.checklistGroupId === group.checklistGroupId,
        );

        if (!findGroup) return;

        group.checklistGroupScore = findGroup.checklistGroupScore;
        group.checklistGroupScoreMax = findGroup.checklistGroupScoreMax;
        group.scoreIncreaseFirstCount = findGroup.scoreIncreaseFirstCount;
        group.scoreIncreaseTotal = findGroup.scoreIncreaseTotal;
      });
    },
    SET_LIST_CHECK_LIST_GROUP_ID: (state: any, payload: any) => {
      state.listCheckListGroupId = payload;
    },

    SET_FILTER_CHECKLIST_GROUP_TEMPLATE: (state: any, payload: any) => {
      state.listFilterCheckListGroupTemplate = payload;
    },
    SET_CHECKLIST_GROUP_DATA: (state: any, payload: any) => {
      const checklistItems = payload.checklistItems;
      const checklistItemsDetails = checklistItems.map((item: any) => {
        const checklistItemDetails = state.checklistAssessmentQuestion.find(
          (question: any) => question.checklistItemId === item,
        );
        return checklistItemDetails;
      });
      payload.checklistItems = checklistItemsDetails;
      state.checklistGroupData = payload;
    },
    SET_CHECKLIST_GROUP_TEMPLATE_METRICS: (state: any, payload: any) => {
      state.ChecklistGroupTemplateMetrics = payload;
    },
    SET_CHECKLIST_ASSESSMENT_QUESTION: (state: any, payload: any) => {
      state.checklistAssessmentQuestions = payload;
      state.isFetchingChecklistAssessmentQuestion = false;
    },
    SET_RECOM_CHECKLIST_METRICS: (state: any, payload: any) => {
      state.checklistMetrics = payload;
    },
    UPDATE_ANSWER_CHECKLIST: async (
      state,
      {
        checklistItemData,
        answer,
        type = ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE,
      },
    ) => {
      let checklistItem;

      const findItem = (
        array: IAssessmentChecklistItem[],
        checklistItemId: number,
      ) => {
        for (const item of array) {
          if (item.checklistItemId === checklistItemId) {
            checklistItem = item;
            break;
          }
          findItem(item.checklistChildren || [], checklistItemId);
        }
      };

      findItem(
        state.checklistAssessmentQuestions,
        checklistItemData.checklistItemId,
      );

      const assessmentQuestionTypes =
        store.state.Assessment.assessmentQuestionTypes;

      if (checklistItem) {
        checklistItem = await updateChecklistAnswer(
          assessmentQuestionTypes,
          state.checklistReportId || state.latestChecklistDetail.checklistId,
          checklistItem,
          answer,
          type,
        );

        store.dispatch("Recommend/fetchChecklistAssessmentQuestion");

        // Update current score at cyber health score.
        store.dispatch("Recommend/fetchRecomChecklistMetrics");

        // Update checklist group metrics only score.
        store.dispatch("Recommend/updateReCommentsChecklistGroupMetricsScore");
      }
    },
    SET_CHECKLIST_REPORT_ID: (state: any, id: number) => {
      if (id === state.checklistReportId) return;
      localStorage.setItem(localStorageKey.checklistReportId, id.toString());
      state.checklistReportId = id;
    },
    SET_CHECKLIST_DATAS: (state: any, payload: any) => {
      state.checklists = payload;
    },
    SET_SELECTED_ACTIONS_ROW: (state: any, payload: any) => {
      state.selectedActionsRow = payload;
    },
    SET_SELECTED_ASSESSMENT_QUESTIONS: (state: any, payload) => {
      state.selectedChecklistAssessmentQuestions = payload;
    },
    SET_DATA_ACTION: (state: any, payload: any) => {
      if (Object.keys(payload).length === 0) state.dataAction = {};
      state.dataAction = { ...state.dataAction, ...payload };
    },
    SET_CHECKLIST_ASSESSMENT_QUESTIONS: (state: any, payload) => {
      if (!payload) {
        state.deletedChecklistsAssessment = [];
      } else {
        state.deletedChecklistsAssessment.push(payload);
      }
    },
    REMOVE_SELECTED_ASSESSMENT_QUESTIONS: (state: any, payload) => {
      if (!payload) {
        state.selectedChecklistAssessmentQuestions = [];
        return;
      }
      state.selectedChecklistAssessmentQuestions =
        state.selectedChecklistAssessmentQuestions.filter(
          (item) => item.checklistItemId !== payload,
        );
    },
    REMOVE_CHECKLIST_ITEM_GROUP: (
      state: any,
      { checklistItemIdsToDelete, countDeleted, checklistGroupId },
    ) => {
      if (checklistItemIdsToDelete) {
        state.checklistAssessmentQuestions =
          state.checklistAssessmentQuestions.filter(
            (item) => !checklistItemIdsToDelete.includes(item.checklistItemId),
          );
      }

      if (countDeleted) {
        state.recommendChecklistGroupMetrics.map((group: any) => {
          if (group.checklistGroupId === checklistGroupId) {
            group.checklistGroupItemCount =
              group.checklistGroupItemCount - countDeleted;
          }
        });
      }
    },
    SET_IS_CHANGE_TITLE_ACTION: (state: any) => {
      state.isChangeTitleAction = true;
    },
    SET_IS_CHANGE_DESCRIPTION_ACTION: (state: any) => {
      state.isChangeDescriptionAction = true;
    },
    SET_IS_CHANGE_EDIT_ACTION: (state: any) => {
      state.isChangeTitleAction = false;
      state.isChangeDescriptionAction = false;
      state.deletedChecklistsAssessment = [];
    },
    SET_IS_CREATING_ACTION: (state: any, isCreating: boolean) => {
      state.isCreatingAction = isCreating;
    },
    SET_LIST_STEP_ACTIONS_PLAN: (state: any, payload: any) => {
      if (payload) {
        state.listStepActionsPlan = payload;
      } else {
        state.listStepActionsPlan = [];
      }
    },
    SET_LIST_STEP_VALIDATION_STATE: (state: any, payload: any) => {
      state.listStepActionsPlan = state.listStepActionsPlan.map((item) => {
        if (item.id === payload.id) {
          return { ...item, isValid: payload.isValid };
        }
        return item;
      });
    },
    SET_LIST_STEP_REMOVED: (state: any, payload: any) => {
      if (!payload) {
        state.listStepRemoved = [];
        return;
      }
      state.listStepRemoved.push(payload);
    },
  },
  actions: {
    fetchChecklistStatus: async ({ state }: any) => {
      try {
        const res = await getCheckListStatusDetails(
          state.checklistReportId || state.latestChecklistDetail.checklistId,
        );
        const status: string = get(res, "data.data.checklistStatusId", "");
        state.checklistStatus = status;
        return status;
      } catch (e) {
        return "";
      }
    },
    fetchChecklistData: async ({ state, commit }: any) => {
      try {
        const res = await getDataChecklist();
        const data = res.data.data;

        const checklistsSort = data.sort(
          (a, b) => b.checklistId - a.checklistId,
        );

        // make parent is non hierarchical const parents = makeParentNonHierarchical(e.checklistParent, []);
        const checklists = checklistsSort.map((e: any) => {
          if (!e.checklistParent) {
            return e;
          }
          const parentsData = makeParentNonHierarchical(e.checklistParent, []);
          const parents = parentsData.filter(
            (item: any) =>
              item.checklistIsArchived === false ||
              item.checklistStatusId !== checklistStatusId.defunct,
          );
          return {
            ...e,
            checklistParentHierarchy: e.checklistParent,
            checklistParent: parents,
          };
        });
        const checklistTreeWithoutArchived: any = [];
        const tempChecklistTreeWithoutArchived = checklists.filter(
          (item: any) =>
            item.checklistIsArchived === false ||
            item.checklistStatusId !== checklistStatusId.defunct,
        );
        checklists.forEach((item: any) => {
          if (
            item.checklistIsArchived === false ||
            item.checklistStatusId !== checklistStatusId.defunct
          ) {
            checklistTreeWithoutArchived.push(item);
          } else {
            let isFoundParent = false;
            if (item.checklistParent && item.checklistParent.length > 0) {
              // find parent of item which is not parent of any other chain
              let oldChain = item.checklistParent;
              item.checklistParent.forEach((child: any) => {
                if (
                  !isFoundParent &&
                  tempChecklistTreeWithoutArchived.length > 0
                ) {
                  const parent = tempChecklistTreeWithoutArchived.find(
                    (parentItem: any) =>
                      parentItem.checklistId === child.checklistId ||
                      (parentItem.checklistParent &&
                        parentItem.checklistParent.find(
                          (e: any) => e.checklistId === child.checklistId,
                        )),
                  );
                  oldChain = oldChain.filter(
                    (e: any) => e.checklistId !== child.checklistId,
                  );
                  if (!parent) {
                    isFoundParent = true;
                    checklistTreeWithoutArchived.push({
                      ...child,
                      checklistParent: oldChain,
                    });
                  }
                }
              });
            }
          }
        });
        const sortChecklist = checklistTreeWithoutArchived.sort(
          (a, b) =>
            new Date(b.checklistDateCreated).getTime() -
            new Date(a.checklistDateCreated).getTime(),
        );
        const latestChecklist = sortChecklist[0];
        let checklist;
        if (latestChecklist) {
          // find checklist from checklists or checklists.checklistParent
          state.checklistReportId &&
            checklists.forEach((item) => {
              if (item.checklistId === state.checklistReportId) {
                checklist = item;
              }
              if (item.checklistParent) {
                item.checklistParent.forEach((child) => {
                  if (child.checklistId === state.checklistReportId) {
                    checklist = item;
                  }
                });
              }
            });

          checklist = state.checklistReportId ? checklist : latestChecklist;
          if (!state.checklistReportId) {
            commit(
              "SET_CHECKLIST_REPORT_ID",
              localStorage.getItem(localStorageKey.checklistReportId)
                ? Number(
                    localStorage.getItem(localStorageKey.checklistReportId),
                  )
                : latestChecklist.checklistId,
            );
          }
        }
        commit("SET_CHECKLIST_DATAS", sortChecklist ?? []);
        commit("SET_CHECKLIST_DATA", latestChecklist ?? {});
        return { latestChecklist, checklist, checklists: sortChecklist };
      } catch (e) {
        showErrorAPI(e, Checklist.getChecklists);
        return {};
      }
    },
    fetchChecklistForecasts: async ({ state }) => {
      try {
        const checklistId =
          state.checklistReportId ?? state.latestChecklistDetail?.checklistId;
        const res = await getDataChecklistForecasts(checklistId);
        state.dataChecklistForecasts = res.data.data;
      } catch (e) {
        showErrorAPI(e, Checklist.getChecklistForecasts);
      }
    },
    fetchCategories: async ({ state }) => {
      try {
        const id =
          state.checklistReportId || state.latestChecklistDetail?.checklistId;
        await store.dispatch("Assessment/fetchCategories", {
          checklistId: id,
          reload: true,
        });
      } catch (e) {
        // do
      }
    },
    fetchChecklistAssessmentQuestion: async ({ commit, state }) => {
      try {
        state.isFetchingChecklistAssessmentQuestion = true;
        const id =
          state.checklistReportId || state.latestChecklistDetail?.checklistId;
        const categories = store.getters["Assessment/getCategoriesDetails"];
        const res = await getChecklistAll(id);
        const checklist: any[] = get(res, "data.data.checklistItems", []);
        const checklistAllSorted = initialChecklistByCategory(
          checklist,
          categories,
        );

        const loop = (
          array: IAssessmentQuestionTable[],
          parent?: IAssessmentQuestionTable,
        ) => {
          const output: IAssessmentQuestionTable[] = [];
          for (const item of array) {
            item.id = item.checklistItemId;
            if (parent) {
              const subCategory =
                parent.checklistItemHeadingLabel ||
                parent.checklistItemName ||
                "";
              if (
                parent.checklistItem2ndSubCategoryLabel ||
                parent.checklistItem3ndSubCategoryLabel
              ) {
                item.checklistItem2ndSubCategoryLabel = [
                  ...(parent.checklistItem2ndSubCategoryLabel || []),
                  ...(parent.checklistItem3ndSubCategoryLabel || []),
                ];
                item.checklistItem3ndSubCategoryLabel = [subCategory];
              } else {
                item.checklistItem2ndSubCategoryLabel = [subCategory];
              }
            }
            if (item.checklistChildren) {
              item.checklistChildren = loop(
                item.checklistChildren as IAssessmentQuestionTable[],
                item,
              );
            }
            output.push(item);
          }
          return output;
        };
        const pruneParent = (
          array: IAssessmentQuestionTable[],
          orderNumber = 0,
        ) => {
          const output: IAssessmentQuestionTable[] = [];
          array?.forEach((item) => {
            if (item.checklistChildren) {
              item.checklistChildren?.forEach((child) => {
                child.orderNumber = `${++orderNumber}`;
                output.push(child as IAssessmentQuestionTable);
              });
            } else {
              output.push(item as IAssessmentQuestionTable);
            }
          });
          return output;
        };
        const reOrder = (
          array?: IAssessmentQuestionTable[],
          parentOrderNumber?: string,
        ) => {
          array?.forEach((item, index) => {
            if (parentOrderNumber) {
              item.orderNumber = `${parentOrderNumber}.${index + 1}`;
            }
            reOrder(
              item.checklistChildren as IAssessmentQuestionTable[],
              item.orderNumber,
            );
          });
        };

        let checklistAssessmentQuestions = loop(
          checklistAllSorted as IAssessmentQuestionTable[],
        );
        checklistAssessmentQuestions = pruneParent(
          checklistAssessmentQuestions,
        );
        reOrder(checklistAssessmentQuestions);

        commit(
          "SET_CHECKLIST_ASSESSMENT_QUESTION",
          checklistAssessmentQuestions,
        );
      } catch (error) {
        showErrorAPI(error, Assessment.getChecklistAll);
        commit("SET_CHECKLIST_ASSESSMENT_QUESTION", []);
      }
    },
    fetchChecklistGroupMetrics: async (
      { state, commit },
      payload: any = {},
    ) => {
      const { checklistId } = payload;
      try {
        const checklistGroups = await getChecklistGroups(
          checklistId ||
            state.checklistReportId ||
            state.latestChecklistDetail.checklistId,
        );
        state.checklistGroups = checklistGroups?.data?.data?.checklistGroups;
        commit("SET_CHECKLIST_GROUP_METRICS", []);
        if (
          checklistGroups.status !== successStatusCodes.OK ||
          checklistGroups?.data?.data?.checklistGroups.length === 0
        )
          return;
        const listGroupId = checklistGroups?.data?.data?.checklistGroups.map(
          (group: any) => group.checklistGroupId,
        );
        const res = await getChecklistGroupMetrics(
          checklistId || state.checklistReportId,
          listGroupId,
        );
        if (res.status === successStatusCodes.OK) {
          res?.data?.data?.groupMetrics.forEach((group: any) => {
            group.id = group.checklistGroupId;
            group.title = group.checklistGroupName;
            group.scoreIncreaseFirstCount = group.checklistGroupScore;
            group.scoreIncreaseTotal = group.checklistGroupScoreMax;
            group.riskDetails = group.riskDetails.map((childRisk) => {
              return {
                ...childRisk,
                riskValue:
                  childRisk.riskProbabilityLevelValue *
                  childRisk.riskImpactLevelValue,
              };
            });
            group.relativeRiskValue =
              (+group.checklistGroupScoreMax - group.checklistGroupScore) *
              Number(group.riskProbabilityLevelValueMax) *
              Number(group.riskImpactLevelValueMax);
          });
          const arr_relativeRiskValue = res?.data?.data?.groupMetrics.map(
            (item) => item.relativeRiskValue,
          );
          state.percentileChecklistGroupMetrics = {
            percentile_90: calculatePercentile(arr_relativeRiskValue, 90),
            percentile_75: calculatePercentile(arr_relativeRiskValue, 75),
            percentile_33: calculatePercentile(arr_relativeRiskValue, 100 / 3),
          };
          commit(
            "SET_CHECKLIST_GROUP_METRICS",
            res?.data?.data?.groupMetrics || [],
          );
        } else {
          showError(
            res.data.data.message ||
              getComponentUiText("app-exception-handler-error-unknown-error"),
          );
        }
      } catch (error) {
        showErrorAPI(error, Checklist.getChecklistGroups);
      }
    },
    updateReCommentsChecklistGroupMetricsScore: async ({ state, commit }) => {
      const checklistGroups = await getChecklistGroups(
        state.checklistReportId || state.latestChecklistDetail.checklistId,
      );

      if (
        checklistGroups.status !== successStatusCodes.OK ||
        checklistGroups?.data?.data?.checklistGroups.length === 0
      )
        return;

      const listGroupId = checklistGroups?.data?.data?.checklistGroups.map(
        (group: any) => group.checklistGroupId,
      );

      const res = await getChecklistGroupMetrics(
        state.checklistReportId || state.latestChecklistDetail.checklistId,
        listGroupId,
      );

      if (res.status !== successStatusCodes.OK) return;

      res?.data?.data?.groupMetrics.forEach((group: any) => {
        group.id = group.checklistGroupId;
        group.scoreIncreaseFirstCount = group.checklistGroupScore;
        group.scoreIncreaseTotal = group.checklistGroupScoreMax;
      });

      commit(
        "UPDATE_RECOM_CHECKLIST_GROUP_METRICS_SCORE",
        res?.data?.data?.groupMetrics || [],
      );
    },
    fetchRecomChecklistGroupMetrics: async ({ state, commit }) => {
      const checklistGroups = await getChecklistGroups(
        state.checklistReportId || state.latestChecklistDetail.checklistId,
      );
      state.checklistGroups = checklistGroups?.data?.data?.checklistGroups;
      commit("SET_FILTER_CHECKLIST_GROUP_TEMPLATE", []);
      commit("SET_RECOM_CHECKLIST_GROUP_METRICS", []);
      commit("SET_FILTER_CHECKLIST_GROUP_TEMPLATE", []);

      if (
        checklistGroups.status !== successStatusCodes.OK ||
        checklistGroups?.data?.data?.checklistGroups.length === 0
      )
        return;
      const listGroupId = checklistGroups?.data?.data?.checklistGroups.map(
        (group: any) => group.checklistGroupId,
      );
      const res = await getChecklistGroupMetrics(
        state.checklistReportId || state.latestChecklistDetail.checklistId,
        listGroupId,
      );
      if (res.status === successStatusCodes.OK) {
        res?.data?.data?.groupMetrics.forEach((group: any) => {
          group.id = group.checklistGroupId;
          group.title = group.checklistGroupName;
          group.scoreIncreaseFirstCount = group.checklistGroupScore;
          group.scoreIncreaseTotal = group.checklistGroupScoreMax;
          group.riskDetails = group.riskDetails.map((childRisk) => {
            return {
              ...childRisk,
              riskValue:
                childRisk.riskProbabilityLevelValue *
                childRisk.riskImpactLevelValue,
            };
          });
          group.relativeRiskValue =
            (+group.checklistGroupScoreMax - group.checklistGroupScore) *
            Number(group.riskProbabilityLevelValueMax) *
            Number(group.riskImpactLevelValueMax);
        });
        const arr_relativeRiskValue = res?.data?.data?.groupMetrics.map(
          (item) => item.relativeRiskValue,
        );
        state.recommendPercentileChecklistGroupMetrics = {
          percentile_90: calculatePercentile(arr_relativeRiskValue, 90),
          percentile_75: calculatePercentile(arr_relativeRiskValue, 75),
          percentile_33: calculatePercentile(arr_relativeRiskValue, 100 / 3),
        };
        const promises = res?.data?.data?.groupMetrics.map((group: any) => {
          return getDataChecklistGroup(
            res.data.data.checklistId,
            group.checklistGroupId,
          );
        });
        const results = await Promise.all(promises);
        let arr: any = [];
        results.forEach((result) => {
          arr = [...arr, ...result.data.data.checklistItems];
        });
        commit("SET_FILTER_CHECKLIST_GROUP_TEMPLATE", arr);
        commit(
          "SET_RECOM_CHECKLIST_GROUP_METRICS",
          res?.data?.data?.groupMetrics || [],
        );
      } else {
        showError(
          res.data.data.message ||
            getComponentUiText("app-exception-handler-error-unknown-error"),
        );
      }
    },
    fetchChecklistGroup: async (
      { commit }: any,
      { checklistId, checklistGroupId },
    ) => {
      const {
        data: { data: data },
      } = await getDataChecklistGroup(checklistId, checklistGroupId);
      commit("SET_CHECKLIST_GROUP_DATA", data);
    },
    fetchSuggestedActionData: async ({ state, commit }: any) => {
      try {
        const res = await getChecklistGroupTemplateMetrics(
          state.checklistReportId || state.latestChecklistDetail.checklistId,
        );
        const dataFormat: any = res?.data?.data?.groupMetrics.map(
          (i: ISuggestedActionDetail) => {
            return {
              id: i.checklistGroupTemplateId,
              title: i.checklistGroupTemplateName,
              scoreIncreaseTotal: i.checklistGroupTemplateScoreMax,
              scoreIncreaseFirstCount: i.checklistGroupTemplateScore,
              checklistGroupItemCount: i.checklistGroupTemplateItemCount,
              checklistGroupDescription: i.checklistGroupTemplateDescription,
              isSuggested: i?.checklistItemGroupIds?.length > 0 ? false : true,
              ...i,
              riskDetails: i.riskDetails.map((childRisk) => {
                return {
                  ...childRisk,
                  riskValue:
                    childRisk.riskProbabilityLevelValue *
                    childRisk.riskImpactLevelValue,
                };
              }),
              relativeRiskValue:
                (+i.checklistGroupTemplateScoreMax -
                  i.checklistGroupTemplateScore) *
                Number(i.riskProbabilityLevelValueMax) *
                Number(i.riskImpactLevelValueMax),
            };
          },
        );
        const arr_relativeRiskValue = dataFormat.map(
          (item) => item.relativeRiskValue,
        );
        state.percentileChecklistGroupTemplateMetrics = {
          percentile_90: calculatePercentile(arr_relativeRiskValue, 90),
          percentile_75: calculatePercentile(arr_relativeRiskValue, 75),
          percentile_33: calculatePercentile(arr_relativeRiskValue, 100 / 3),
        };
        commit("SET_CHECKLIST_GROUP_TEMPLATE_METRICS", dataFormat);
      } catch (error) {
        commit("SET_CHECKLIST_GROUP_TEMPLATE_METRICS", []);
        throw error;
      }
    },
    fetchRecomChecklistMetrics: async ({ state, commit }) => {
      const res = await getMetricFromChecklistId(
        state.checklistReportId || state.latestChecklistDetail.checklistId,
      );

      commit("SET_RECOM_CHECKLIST_METRICS", res?.data?.data || {});
    },
    updateAnswer: async ({ commit }, payload) => {
      const { answer, type } = payload.data;
      commit("UPDATE_ANSWER_CHECKLIST", {
        checklistItemData: payload.checklistItemData,
        answer,
        type,
      });
    },
    createActionData: async ({ state, commit }: any, data) => {
      try {
        let payload = data.addedActions;
        let res;
        if (data.isSuggestionsAction) {
          if (!payload || payload.length === 0) {
            payload = state.ChecklistGroupTemplateMetrics;
          }
          const checklistGroupCallback = payload.map(
            async (item: any) =>
              await createChecklistGroupMetrics(
                state.checklistReportId ||
                  state.latestChecklistDetail.checklistId,
                item.checklistGroupTemplateId,
              ),
          );
          await Promise.all(checklistGroupCallback);
          const ids = payload.map((item: any) => item.checklistGroupTemplateId);
          const data = state.ChecklistGroupTemplateMetrics.map((i: any) => {
            if (ids.includes(i.checklistGroupTemplateId)) {
              return {
                ...i,
                isSuggested: false,
              };
            } else {
              return i;
            }
          });

          commit("SET_CHECKLIST_GROUP_TEMPLATE_METRICS", data);
          return true;
        } else {
          res = await addChecklistItemToExistChecklistItemGroup(
            data.checklistGroupId,
            data.addedActions,
          );
        }
        if (res.status === successStatusCodes.OK) {
          return true;
        } else {
          showError(
            res.data.data.message ||
              getComponentUiText("app-exception-handler-error-unknown-error"),
          );
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    fetchCheckListGroupTemplates: async ({ commit, state }) => {
      try {
        const res = await getChecklistGroupTemplates();
        const filterChecklistGroupTemplates = res.data.data
          .filter((e) => e?.checklistItemGroupIds?.length > 0)
          .flatMap((item) => {
            return item.checklistItemGroupIds || [];
          });
        const listChecklistGroupId = state.checklistGroupMetrics.flatMap(
          (item) => {
            if (filterChecklistGroupTemplates.includes(item.checklistGroupId)) {
              return item.checklistGroupTemplateIds;
            }
          },
        );
        commit("SET_LIST_CHECK_LIST_GROUP_ID", listChecklistGroupId || []);
      } catch (error) {
        showErrorAPI(error, Checklist.getChecklistItemGroupTemplates);
        return error;
      }
    },
    updateActionData: async ({ commit }: any, data: any) => {
      commit("SET_CHECKLIST_GROUP_METRICS", data || []);
    },
    setChecklistReportId: ({ commit }: any, id: number) => {
      commit("SET_CHECKLIST_REPORT_ID", id);
    },
    removeActions: async ({ _, state }: any) => {
      try {
        const res = await removeActionTable({
          checklistId: state.checklistReportId,
          checklistGroupIds: state.selectedActionsRow.map(
            (item) => item.checklistGroupId,
          ),
        });
        if (res.status === successStatusCodes.OK) {
          const emitData: IToastMessage = {
            variant: ToastVariant.SUCCESS,
            message: getComponentUiText(
              "app-assess-recommend-action-delete-actions-successfully-1",
            ),
          };
          eventEmitter.emit(
            EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
            emitData,
          );
        }
      } catch (error) {
        showErrorAPI(error, Checklist.removeActionTable);
      }
    },
    createAction: async ({ state }: any) => {
      const description = JSON.stringify({
        image:
          "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",
        description: state.dataAction.description,
      });

      try {
        const res = await postChecklistGroup({
          checklistId: state.checklistReportId,
          checklistItemIds: state.selectedChecklistAssessmentQuestions.map(
            (item) => item.checklistItemId,
          ),
          ...state.dataAction,
          description: description,
        });
        if (res.status === successStatusCodes.OK) {
          return res.data.data;
          showToastMessage(
            getComponentUiText("app-added-action-successfully"),
            ToastVariant.SUCCESS,
          );
        }
      } catch (error) {
        showErrorAPI(error, Checklist.updateChecklistItemGroup);
      }
    },
    updateAction: async ({ state }: any, checklistGroupId) => {
      const description = JSON.stringify({
        image:
          "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",
        description: state.dataAction.description,
      });
      const prams = {
        checklistId: state.checklistReportId,
        checklistGroupId,
        checklistItemIdsToAdd: state.selectedChecklistAssessmentQuestions.map(
          (item) => item.checklistItemId,
        ),
        ...state.dataAction,
        checklistItemIdsToRemove: state.deletedChecklistsAssessment,
        description: description,
      };
      if (
        Array.isArray(prams.checklistItemIdsToAdd) &&
        prams.checklistItemIdsToAdd.length === 0
      ) {
        delete prams.checklistItemIdsToAdd;
      }

      if (
        Array.isArray(prams.checklistItemIdsToRemove) &&
        prams.checklistItemIdsToRemove.length === 0
      ) {
        delete prams.checklistItemIdsToRemove;
      }
      try {
        const res = await putChecklistGroup(prams);
        if (res.status === successStatusCodes.OK) {
          showToastMessage(
            getComponentUiText("app-updated-action-successfully"),
            ToastVariant.SUCCESS,
          );
        }
      } catch (error) {
        showErrorAPI(error, Checklist.updateChecklistItemGroup);
      }
    },
    updateSuggestedAction: async ({ state }: any, groupTemplateId) => {
      const params = {
        ...state.dataAction,
        removeItemMasterIds: state.deletedChecklistsAssessment,
      };
      if (
        Array.isArray(params.removeItemMasterIds) &&
        params.removeItemMasterIds.length === 0
      ) {
        delete params.removeItemMasterIds;
      }
      try {
        await putChecklistSuggestedAction(groupTemplateId, params);
      } catch (error) {
        showErrorAPI(error, Checklist.putChecklistSuggestedAction);
      }
    },
    reorderAction: async ({ _state }: any, data) => {
      try {
        return await putChecklistGroup(data);
      } catch (error) {
        showErrorAPI(error, Checklist.updateChecklistItemGroup);
        return error;
      }
    },
    bulkReorderAction: async ({ _state }: any, payload) => {
      try {
        if (payload.data.length === 0) return;

        // Create a new array to store the reordered result
        const reorderedArray: any[] = payload.data.map((item, index) => {
          return {
            checklistId: payload.checklistId,
            checklistGroupId: item.checklistGroupId,
            order: (index + 1) * 10 - 1,
          };
        });

        for (const checklistGroup of reorderedArray) {
          await putChecklistGroup(checklistGroup);
        }
      } catch (error) {
        showErrorAPI(error, Checklist.updateChecklistItemGroup);
      }
    },
    removeChecklistGroup: async (
      { _state, commit }: any,
      { checklistItemGroupId, checklistItemIdsToDelete },
    ) => {
      try {
        const {
          data: {
            data: { countDeleted },
          },
        } = await deleteChecklistItemGroup(
          checklistItemGroupId,
          checklistItemIdsToDelete,
        );

        commit("REMOVE_CHECKLIST_ITEM_GROUP", {
          checklistItemIdsToDelete,
          countDeleted,
          checklistGroupId: checklistItemGroupId,
        });
      } catch (error) {
        showErrorAPI(error, Checklist.deleteChecklistGroupItems);
      }
    },
  },
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
export default recommendModule;
